module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochd"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter1"
    }
  }, [_c('span', {
    staticClass: "tocpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" General Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter2"
    }
  }, [_c('span', {
    staticClass: "tocpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" Warfare and Imperialism in Early Carthage")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter3"
    }
  }, [_c('span', {
    staticClass: "tocpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" Armies Against Syracuse")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" The Wars with Dionysius I of Syracuse")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" Timoleon, Agathocles, and Pyrrhus")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" The First War with Rome")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])]), _vm._v(" The Truceless War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])]), _vm._v(" The Second War with Rome")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")])]), _vm._v(" Killing a Phoenix: The End of Carthage")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")])]), _vm._v(" Punic Warfare: Conclusions")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1318eeb7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0